export default {
  getAllWines(state) {
    return state.wines
  },
  getWineById: state => id => {
    return state.wines.find(wine => wine.id === id)
  },
}
